module.exports = __webpack_public_path__ + "static/media/no-image.e4eba325.png";